/**
 * 直接获取到workbench那一层的window对象
 * @returns window对象
 */
 export function getTopWindow() {
    //说明已经是顶层window
    if (window.parent === window) {
        return window;
    }
    //说明是登录页
    if (window.location.href.includes('login/main/index.html')) {
        return window
    }
    //说明是workbench的最外层了
    let flag = window.document.body.getAttribute('id') === 'workbench';
    if (flag) {
        return window;
    }

    if (window.frameElement && window.frameElement.getAttribute('id') == 'mainiframe') {
        return window.parent;
    } else if (window.parent.frameElement && window.parent.frameElement.getAttribute('id') == 'mainiframe') {
        return window.parent.parent;
    } else if (window.parent.parent.frameElement && window.parent.parent.frameElement.getAttribute('id') == 'mainiframe') {
        return window.parent.parent.parent;
    } else {
        return window.parent.parent.parent.parent;
    }
}
/**
 * 保证ncc系统内部使用获取到的window.parent不超出workbench那一层
 * @param {Object} pWindow window对象
 * @returns window对象
 */
export function getParentWindow(pWindow) {
    //说明已经是顶层window
    if (pWindow.parent === pWindow) {
        return pWindow
    }
    //说明是登录页
    if (pWindow.location.href.includes('login/main/index.html')) {
        return pWindow
    }
    //说明是workbench的最外层了
    let flag = pWindow.document.body.getAttribute('id') === 'workbench';
    if (flag) {
        return pWindow;
    }
    return pWindow.parent;
}
